import { useState, useEffect } from "react";
import { sortLeftRightTopBottom } from "../../../refractCommon/miro/sortLeftRightTopBottom";
import { RGBAStringToHex } from "./Colors_Utils";
import ColorPicker, { useColorPicker } from "react-best-gradient-color-picker";
import ToolTip from "../../../refractCommon/components/ToolTip";

const miro = window.miro;

export default function OneColor({ boardSelection }) {
  const [color, setColor] = useState("rgba(108, 108, 220, 1)");
  const [styleSelection, setStyleSelection] = useState({
    text: false,
    stroke: false,
    fill: true,
  });

  const [
    canColorFillSomeSelectedItemsOnBoard,
    setCanColorFillSomeSelectedItemsOnBoard,
  ] = useState(false);
  // State for color extractor
  const [extractedColors, setExtractedColors] = useState([]);
  const [url, setUrl] = useState(
    "https://hips.hearstapps.com/harpersbazaaruk.cdnds.net/17/40/2048x1024/landscape-1506942420-los-angeles-skyline.jpg?resize=480:*"
  );
  const [imageItem, setImageItem] = useState({});
  const [colorCount, setColorCount] = useState(6);

  useEffect(() => {
    checkSelectionAndSetCapabilityState();
  }, [boardSelection]);

  async function checkSelectionAndSetCapabilityState() {
    let selection = await miro.board.getSelection();
    if (selection.length < 1) {
      setCanColorFillSomeSelectedItemsOnBoard(false);
      return;
    }
    if (selection.length === 1) {
      if (selection[0].type === "shape") {
        setCanColorFillSomeSelectedItemsOnBoard(true);
      }
    }
    if (selection.length > 1) {
      let types = selection.map((item) => item.type);
      if (types.includes("shape")) {
        setCanColorFillSomeSelectedItemsOnBoard(true);
      }
    }
  }

  async function addNewItemWithColor(flag) {
    let viewport = await miro.board.viewport.get();
    // let selection = await miro.board.getSelection();
    // let validItemTypes = ["shape"];
    // let filteredSelection = selection.filter((item) =>
    //   validItemTypes.includes(item.type)
    // );
    let startPointX = viewport.width * 0.4 + viewport.x;
    let startPointY = viewport.height / 2 + viewport.y;
    let sizeOfSquare = viewport.width / 20;
    let horizontalBufferScale = 0.1;

    let hexColor = RGBAStringToHex(color);

    let swatchItem = await miro.board.createShape({
      shape: "rectangle",
      style: {
        fillColor: hexColor,
      },
      x: startPointX,
      y: startPointY,
      width: sizeOfSquare,
      height: sizeOfSquare,
    });
  }

  async function fillItemsWithColor(flag) {
    let viewport = await miro.board.viewport.get();
    let selection = await miro.board.getSelection();
    let validItemTypes = ["shape"];
    let filteredSelection = selection.filter((item) =>
      validItemTypes.includes(item.type)
    );

    let sortedSelection = sortLeftRightTopBottom(filteredSelection);

    let colorToFillWith = RGBAStringToHex(color);

    for (let i = 0; i < sortedSelection.length; i++) {
      sortedSelection[i].style.fillColor = colorToFillWith;
      sortedSelection[i].sync();
    }
  }
  return (
    <div className="cs1 ce12 grid">
      <div className="cs1 ce12 grid   pr-0 pl-0 pb-0 mt-8">
        <div
          className="cs1 ce12 mt-8f
         color-picker-fix-1-color">
          <ColorPicker
            className="cs1 ce12 mr-0 ml-0 pl-0 pr-0 mt-0 pt-0"
            value={color}
            hideControls={true}
            hidePresets={true}
            hideEyeDrop={true}
            width={350}
            hideAdvancedSliders={true}
            onChange={setColor}
          />
        </div>
      </div>

      <div className="cs1 ce12 grid "></div>
      <hr className="cs1 ce12 mt-0"></hr>
      <p className="cs5 ce12 mb-0 mt--4 p-small">
        <b>Use the color:</b>
      </p>
      <ToolTip
        placement={"top"}
        toolTipContent={"Fill the shape items selected on the board"}>
        <button
          disabled={!canColorFillSomeSelectedItemsOnBoard}
          onClick={() => fillItemsWithColor("all")}
          className="cs5 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-2"
          type="button">
          <span className="icon-download smaller-button-icon"></span>
        </button>
      </ToolTip>
      <ToolTip
        placement={"top"}
        toolTipContent={"Create a new colored square."}>
        <button
          onClick={() => addNewItemWithColor("all")}
          className="cs6 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-2"
          type="button">
          <span className="icon-plus smaller-button-icon"></span>
        </button>
      </ToolTip>
    </div>
  );
}

{
  /* <div
          onClick={() => {
            handleStyleButtonClick("text");
          }}
          className={
            "cs2 text-color-button color-button" +
            " " +
            (styleSelection.text ? "button-selected" : "")
          }>
          <div
            id="text-color-button"
            className="pl-4
             pt-3 ">
            <svg id="text-color-icon" className="icon" viewBox="0 0 24 24">
              <g xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(-8, -14)" id="A-text-color-icon">
                  <path d="M19,17 L13.5,31 L15.75,31 L16.87,28 L23.12,28 L24.24,31 L26.49,31 L21,17 L19,17 L19,17 Z M17.62,26 L20,19.67 L22.38,26 L17.62,26 L17.62,26 Z"></path>
                </g>
                <g transform="translate(0,20)">
                  <g id="bar-beneath-A-text-color-icon">
                    <rect
                      width="24"
                      height="4"
                      fill={styleSelection.text ? `${color}` : "currentColor"}
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div> */
}

{
  /* <div
          onClick={() => {
            handleStyleButtonClick("stroke");
          }}
          id="stroke-color-button"
          className={
            "cs3 color-button" +
            " " +
            (styleSelection.stroke ? "button-selected" : "")
          }>
          <div
            id="stroke-color-icon"
            style={
              styleSelection.stroke
                ? { borderColor: `${color}` }
                : { borderColor: "currentcolor" }
            }></div>
        </div> */
}

{
  /* <div
          id="circle-color-button"
          className={
            "cs4 color-button" +
            " " +
            (styleSelection.fill ? "button-selected" : "")
          }
          onClick={() => {
            handleStyleButtonClick("fill");
          }}>
          <div
            id="circle-color-icon"
            style={
              styleSelection.fill
                ? {
                    backgroundColor: `${color}`,
                    // backgroundImage: "none !important",
                    backgroundImage: "url('')",
                  }
                : {}
            }></div>
        </div> */
}

//
// function handleStyleButtonClick(flag) {
//   let newStyleSelection = { ...styleSelection };

//   switch (flag) {
//     case "text":
//       newStyleSelection.text = !newStyleSelection.text;
//       setStyleSelection(newStyleSelection);
//       break;
//     case "stroke":
//       newStyleSelection.stroke = !newStyleSelection.stroke;
//       setStyleSelection(newStyleSelection);
//       break;
//     case "fill":
//       newStyleSelection.fill = !newStyleSelection.fill;
//       setStyleSelection(newStyleSelection);
//       break;

//     default:
//       setStyleSelection(newStyleSelection);
//   }
// }

// ALL THE IMAGE COLOR EXTRACT STUFF
// async function ingestImage() {
//   let selection = await miro.board.getSelection();
//   let imageUrl;
//   let newImageItem;
//   // let imageId;
//   if (selection.length === 1 && selection[0].type === "image") {
//     newImageItem = selection[0];
//     setImageItem(newImageItem);
//     // imageId = newImageItem.id;

//     if (newImageItem?.url && newImageItem.url !== "") {
//       imageUrl = newImageItem.url;
//       setUrl(newImageItem.url);
//     }
//   }
// }

// function handleExtractColors(colors) {
//   setExtractedColors(colors);
// }

// async function extractColor() {
//   //  A SECTION READY TO GO>.. NEEDS CORS PROOF BACK END REQUEST TO MIRO SERVER FOR FINAL IMAGE URL REQUEST
//   // if (selection.length === 1 && selection[0].type === "image") {
//   //   imageId = selection[0].id;
//   // }
//   // let miroBoardInfo = await miro.board.getInfo();
//   // let boardId = miroBoardInfo.id;
//   // Get the JWT signed with your app client secret.
//   // const token = await miro.board.getIdToken();
//   // const options = {
//   //   method: "GET",
//   //   headers: {
//   //     accept: "application/json",
//   //     Authorization: `Bearer ${token}`,
//   //   },
//   // };
//   // let imageData = await fetch(
//   //   `https://api.miro.com/v2/boards/${boardId}/images/${imageId}`,
//   //   options
//   // )
//   //   .then((response) => response.json())
//   //   .catch((err) => console.error(err));
//   // Pass the JWT with each request from your app to your backend services.
//   // const response2 = await fetch(
//   //   `http://api.miro.com/v2/boards/${boardId}/resources/images/${imageId}?format=preview&redirect=true`,
//   //   {
//   //     method: "GET",
//   //     headers: {
//   //       "Content-Type": "application/json",
//   //       Authorization: `Bearer ${token}`,
//   //     },
//   //   }
//   // );
//   ///////////// END IMAGE URL ATTEMPT
// }

// async function placeSwatchesUnderImage() {
//   ///
//   // place the swatches under the image
//   if (extractedColors.length > 0) {
//     // const imageOriginX = imageItem.x;
//     // const imageOriginY = imageItem.y;
//     const imageBottomLeft_X = imageItem.x - imageItem.width * 0.5;
//     const imageBottomLeft_Y = imageItem.y + imageItem.height * 0.5;

//     const vertBufferFromImage = imageItem.height * 0.1;
//     const horizontalBufferScale = 0.1;
//     const widthOfSwatch =
//       imageItem.width /
//       (colorCount + (colorCount - 1) * horizontalBufferScale);

//     for (let i = 0; i < colorCount; i++) {
//       let swatchItem = miro.board.createShape({
//         content: `<p>${extractedColors[i]}</p>`,
//         shape: "circle",
//         style: {
//           fillColor: extractedColors[i], // Default color: transparent (no fill)
//           fontFamily: "arial", // Default font type for the text
//           fontSize: widthOfSwatch * 0.08, // Default font size in dp for the text
//           textAlign: "center", // Default alignment: center
//           textAlignVertical: "middle", // Default alignment: middle
//         },
//         x:
//           imageBottomLeft_X +
//           widthOfSwatch * i +
//           widthOfSwatch * i * horizontalBufferScale +
//           0.5 * widthOfSwatch,
//         y: imageBottomLeft_Y + vertBufferFromImage + 0.5 * widthOfSwatch, // Default value: center of the board
//         width: widthOfSwatch,
//         height: widthOfSwatch,
//       });
//     }
//   }
// }
